import {
  CONFIRMATION_EMAIL_SENT,
  RESEND_EMAIL_CONFIRMATION_API_URL,
} from 'moduleBase/components/header/confirm-email-notifier/constants';
import { Response, NetworkServiceInterface } from '@collaborator/npm_modules/dist/components/NetworkService';
import { ThunkAction } from 'components/redux/types/ThunkAction';

const confirmEmailSent = () => ({
  type: CONFIRMATION_EMAIL_SENT,
});

const resendConfirmationEmail = (
  networkService: NetworkServiceInterface,
): Promise<Response<void>> => networkService.post<void>(RESEND_EMAIL_CONFIRMATION_API_URL, {});

const resendConfirmationEmailAction = (): ThunkAction<Promise<Response<void>>> => (
  dispatch,
  getState,
  { networkService },
) => resendConfirmationEmail(networkService).then((response) => {
  dispatch(confirmEmailSent());
  return response;
});

export { resendConfirmationEmailAction };
